// Component that shows/hides content based on user permissions
import React from 'react';
import { useUserPermissions } from '../../hooks/useUserPermissions';

const PermissionGate = ({ 
  children, 
  permission, 
  level, 
  group, 
  fallback = null, 
  showLoading = true 
}) => {
  const { permissions, loading } = useUserPermissions();

  if (loading && showLoading) {
    return <div>Loading permissions...</div>;
    return null;
  }

  if (!permissions) {
    return fallback;
  }

  // Check specific permission
  if (permission && !permissions.permissions.includes(permission)) {
    return fallback;
  }

  // Check minimum level
  if (level && permissions.level < level) {
    return fallback;
  }

  // Check specific group (supports multiple groups separated by | for OR logic)
  if (group) {
    // Support multiple groups: "Admin|developers" means Admin OR developers
    const groupsToCheck = group.split('|').map(g => g.trim());
    
    console.log(`[PermissionGate] Checking groups:`, groupsToCheck);
    console.log(`[PermissionGate] User groups:`, permissions.groups);
    console.log(`[PermissionGate] Groups type:`, typeof permissions.groups, Array.isArray(permissions.groups));
    
    // Case-insensitive group matching with OR logic
    const hasGroup = Array.isArray(permissions.groups) && 
                     groupsToCheck.some(requiredGroup => {
                       const normalizedRequired = requiredGroup.toLowerCase();
                       return permissions.groups.some(userGroup => 
                         String(userGroup).trim().toLowerCase() === normalizedRequired
                       );
                     });
    
    console.log(`[PermissionGate] Has any of groups [${groupsToCheck.join(', ')}] (case-insensitive):`, hasGroup);
    
    if (!hasGroup) {
      console.warn(`[PermissionGate] Access denied. User groups: [${permissions.groups.join(', ')}], Required: [${groupsToCheck.join(' OR ')}]`);
      return fallback;
    }
  }

  return children;
};

export default PermissionGate;
